import Modal from 'react-modal';
import Alfredo from '../../../assets/imagens/Alfredo.png'
import Typing from '../../ui/Typing'

import {motion } from 'motion/react'

import './FinalizacaoModal.css'
export default function Finalizacao({showModal, closeModal}){

    const emitirSom = ()=>{
            const audio = new Audio('/sounds/cyber.mp3')
            audio.play().catch(error => console.log("Não foi possível reproduzir este audio: ", error)) 
       }

    return(
        <Modal
            isOpen={showModal}
            onRequestClose={closeModal}
            className='modalFinalizacao'
            overlayClassName="overlayModal"
            onAfterOpen={emitirSom}
        >

            <div className='containerModalDefault'>
                
                <h1 className="titulo">Missão Concluída!</h1>
                <h3>Você fez parte dessa missão</h3>

                <div className='mensagem flex'>
                    <img className='avatarAlfredo' width={150} src={Alfredo} />
                    <div className='areaTexto'>
                        <h2 className='destaque'>Alfredo</h2>
                        <div>
                            <Typing 
                                text="Obrigado por participar da Semana da TI! Esperamos que essa experiência tenha mostrado um pouquinho dos desafios que fazem parte da nossa rotina e da importância da tecnologia no dia a dia."
                                className="textClear"/>
                        </div> 
                    </div>

                </div>

                <motion.button 
                        whileHover={{scale:1.1}}
                        className="btn btnAmarelo"
                        onClick={()=>closeModal()}
                        >
                        Seguir
                    </motion.button>
            </div>


        </Modal>
    )
}